import { AppReviewList } from '../../../models/dto/borrower-fd/application-review.model';

export class UpdateKickback {
  static readonly type = '[Kickback] Update';

  constructor(public kickback: AppReviewList[]) {}

}

export class GetApplicationReviewItems {
  static readonly type = '[ApplicationReviewItem] Get';
  constructor(public borrowerId: number) {}
}
